import {
  Ban,
  CheckCircle2,
  Clock,
  Gauge,
  Loader2,
  ShieldAlert,
  XCircle,
} from "lucide-react";
import type { ComponentType } from "react";
import { useTranslation } from "react-i18next";

import type { TaskStatus } from "@/api/types";
import { Badge, type BadgeProps } from "@/components/ui/badge";

type BadgeVariant = NonNullable<BadgeProps["variant"]>;

/** Mapa puro status -> variant (testavel; exaustivo por tipo). */
export const TASK_STATUS_VARIANT: Record<TaskStatus, BadgeVariant> = {
  queued: "outline",
  running: "default",
  waiting_decision: "warning",
  completed: "success",
  error: "destructive",
  token_limit: "destructive",
  cancelled: "secondary",
};

const TASK_STATUS_ICON: Record<
  TaskStatus,
  ComponentType<{ className?: string }>
> = {
  queued: Clock,
  running: Loader2,
  waiting_decision: ShieldAlert,
  completed: CheckCircle2,
  error: XCircle,
  token_limit: Gauge,
  cancelled: Ban,
};

export function TaskStatusBadge({ status }: { status: TaskStatus }) {
  const { t } = useTranslation("tasks");
  const Icon = TASK_STATUS_ICON[status];
  return (
    <Badge variant={TASK_STATUS_VARIANT[status]}>
      <Icon
        className={
          status === "running" ? "h-3 w-3 animate-spin" : "h-3 w-3"
        }
      />
      {t(`status.${status}`)}
    </Badge>
  );
}
